document.addEventListener('DOMContentLoaded', function() {
    // Initialize variant images on page load
    initializeVariantImages();
    
    // Color option functionality with variant image switching
    const colorOptions = document.querySelectorAll('.color-option');
    
    // Function to initialize variant images on page load
    function initializeVariantImages() {
        const productCards = document.querySelectorAll('.product-card');
        
        productCards.forEach(card => {
            const variantImages = card.querySelectorAll('.variant-image');
            const fallbackPlate = card.querySelector('.fallback-plate');
            
            if (variantImages.length > 0) {
                // Ensure the first variant image is visible by default
                const firstVariantImage = variantImages[0];
                if (firstVariantImage) {
                    firstVariantImage.classList.add('active');
                }
                
                // Hide fallback plate when variant images are available
                if (fallbackPlate) {
                    fallbackPlate.style.opacity = '0';
                    fallbackPlate.style.visibility = 'hidden';
                }
            } else {
                // Show fallback plate when no variant images are available
                if (fallbackPlate) {
                    fallbackPlate.style.opacity = '1';
                    fallbackPlate.style.visibility = 'visible';
                }
            }
        });
    }
    
    colorOptions.forEach(option => {
        option.addEventListener('click', function() {
            // Remove active class from siblings
            const siblings = this.parentElement.querySelectorAll('.color-option');
            siblings.forEach(sibling => sibling.classList.remove('active'));
            
            // Add active class to clicked option
            this.classList.add('active');
            
            // Get the selected color
            const selectedColor = this.getAttribute('data-color');
            
            // Change the product image based on selected color
            const productCard = this.closest('.product-card');
            switchVariantImage(productCard, selectedColor);
        });
    });
    
    // Function to switch variant images
    function switchVariantImage(productCard, selectedColor) {
        const productImage = productCard.querySelector('.product-image');
        const variantImages = productCard.querySelectorAll('.variant-image');
        const fallbackPlate = productCard.querySelector('.fallback-plate');
        
        // Check if variant images exist
        if (variantImages.length > 0) {
            // Hide all variant images
            variantImages.forEach(img => {
                img.classList.remove('active');
            });
            
            // Show the selected variant image
            const targetImage = productCard.querySelector(`.variant-image[data-variant="${selectedColor}"]`);
            if (targetImage) {
                targetImage.classList.add('active');
                
                // Update the variant name display
                updateVariantName(productCard, selectedColor);
            } else {
                console.warn(`No variant image found for color: ${selectedColor}`);
                // If no variant image exists for this color, show the first available one
                if (variantImages[0]) {
                    variantImages[0].classList.add('active');
                    const firstVariantName = variantImages[0].getAttribute('data-variant');
                    updateVariantName(productCard, firstVariantName);
                }
            }
            
            // Hide fallback plate when variant images are available
            if (fallbackPlate) {
                fallbackPlate.style.opacity = '0';
                fallbackPlate.style.visibility = 'hidden';
            }
        } else {
            // No variant images available, use fallback plate with color changes
            if (fallbackPlate) {
                fallbackPlate.style.opacity = '1';
                fallbackPlate.style.visibility = 'visible';
                
                const plateBody = productCard.querySelector('.plate-body');
                const ears = productCard.querySelectorAll('.ear');
                
                if (plateBody && ears.length > 0) {
                    updatePlateColors(plateBody, ears, selectedColor, productCard);
                }
            }
        }
    }
    
    // Function to update variant name display
    function updateVariantName(productCard, variantName) {
        const variantNameElement = productCard.querySelector('.variant-name');
        if (variantNameElement) {
            variantNameElement.textContent = variantName;
        }
    }
    
    // Function to update plate colors based on selected color
    function updatePlateColors(plateBody, ears, selectedColor, productCard) {
        let borderGradient = '';
        
        // Determine if this is Hoppy or Pogo Playte
        const isHoppy = productCard.querySelector('.hoppy-playte');
        
        if (isHoppy) {
            // Hoppy Playte color variations
            switch(selectedColor) {
                case 'purple':
                    borderGradient = 'linear-gradient(45deg, #9b59b6, #e74c3c, #f39c12)';
                    break;
                case 'green':
                    borderGradient = 'linear-gradient(45deg, #2ecc71, #27ae60, #16a085)';
                    break;
                case 'gray':
                    borderGradient = 'linear-gradient(45deg, #95a5a6, #7f8c8d, #34495e)';
                    break;
                default:
                    borderGradient = 'linear-gradient(45deg, #9b59b6, #e74c3c, #f39c12)';
            }
        } else {
            // Pogo Playte color variations
            switch(selectedColor) {
                case 'teal':
                    borderGradient = 'linear-gradient(45deg, #e74c3c, #3498db, #2ecc71)';
                    break;
                case 'green':
                    borderGradient = 'linear-gradient(45deg, #2ecc71, #27ae60, #16a085)';
                    break;
                case 'brown':
                    borderGradient = 'linear-gradient(45deg, #d35400, #e67e22, #f39c12)';
                    break;
                default:
                    borderGradient = 'linear-gradient(45deg, #e74c3c, #3498db, #2ecc71)';
            }
        }
        
        // Apply the new border gradient
        plateBody.style.borderImage = borderGradient + ' 1';
        ears.forEach(ear => {
            ear.style.borderImage = borderGradient + ' 1';
        });
        
        // Add a smooth transition effect
        plateBody.style.transition = 'border-image 0.3s ease';
        ears.forEach(ear => {
            ear.style.transition = 'border-image 0.3s ease';
        });
    }
    
    // Add to cart button functionality
    const addToCartButtons = document.querySelectorAll('.add-to-cart-btn');
    
    addToCartButtons.forEach(button => {
        button.addEventListener('click', function() {
            const productName = this.getAttribute('data-product');
            
            // Get the selected color for this product
            const productCard = this.closest('.product-card');
            const activeColorOption = productCard.querySelector('.color-option.active');
            const selectedColor = activeColorOption ? activeColorOption.getAttribute('data-color') : 'default';
            
            // No loading state needed since we're opening a popup, not adding to cart
            
            // You can add actual cart functionality here
        });
    });
    
    // Product card hover effects
    const productCards = document.querySelectorAll('.product-card');
    
    productCards.forEach(card => {
        card.addEventListener('mouseenter', function() {
            // Add subtle animation to the product plate
            const productPlate = this.querySelector('.product-plate');
            if (productPlate) {
                productPlate.style.transform = 'scale(1.05) rotate(2deg)';
                productPlate.style.transition = 'transform 0.3s ease';
            }
        });
        
        card.addEventListener('mouseleave', function() {
            // Reset the product plate animation
            const productPlate = this.querySelector('.product-plate');
            if (productPlate) {
                productPlate.style.transform = 'scale(1) rotate(0deg)';
            }
        });
    });
    
    // Add floating animation to product plates
    function addFloatingAnimation() {
        const productPlates = document.querySelectorAll('.product-plate');
        
        productPlates.forEach((plate, index) => {
            // Stagger the animation start time
            setTimeout(() => {
                setInterval(() => {
                    plate.style.transform = 'translateY(-5px) scale(1.02)';
                    setTimeout(() => {
                        plate.style.transform = 'translateY(0px) scale(1)';
                    }, 1500);
                }, 3000);
            }, index * 500);
        });
    }
    
    // Start floating animation after page load
    setTimeout(addFloatingAnimation, 1000);
    
    // Add sparkle effect on color option selection
    function createSparkle(element) {
        const sparkle = document.createElement('div');
        sparkle.style.position = 'absolute';
        sparkle.style.width = '4px';
        sparkle.style.height = '4px';
        sparkle.style.background = 'white';
        sparkle.style.borderRadius = '50%';
        sparkle.style.pointerEvents = 'none';
        sparkle.style.zIndex = '1000';
        
        const rect = element.getBoundingClientRect();
        sparkle.style.left = (rect.left + Math.random() * rect.width) + 'px';
        sparkle.style.top = (rect.top + Math.random() * rect.height) + 'px';
        
        document.body.appendChild(sparkle);
        
        // Animate sparkle
        sparkle.animate([
            { transform: 'scale(0) rotate(0deg)', opacity: 1 },
            { transform: 'scale(1) rotate(180deg)', opacity: 0.8 },
            { transform: 'scale(0) rotate(360deg)', opacity: 0 }
        ], {
            duration: 800,
            easing: 'ease-out'
        }).onfinish = () => {
            sparkle.remove();
        };
    }
    
    // Add sparkle effect to color options
    colorOptions.forEach(option => {
        option.addEventListener('click', function() {
            // Create multiple sparkles
            for (let i = 0; i < 5; i++) {
                setTimeout(() => createSparkle(this), i * 100);
            }
        });
    });
    
    // Add pulse effect to ratings
    const ratings = document.querySelectorAll('.product-rating');
    ratings.forEach(rating => {
        setInterval(() => {
            rating.style.transform = 'scale(1.05)';
            setTimeout(() => {
                rating.style.transform = 'scale(1)';
            }, 200);
        }, 5000);
    });
    
    // Add subtle glow effect to save badges
    const saveBadges = document.querySelectorAll('.save-badge');
    saveBadges.forEach(badge => {
        setInterval(() => {
            badge.style.boxShadow = '0 0 15px rgba(231, 76, 60, 0.6)';
            setTimeout(() => {
                badge.style.boxShadow = 'none';
            }, 1000);
        }, 4000);
    });
    
    // Intersection Observer for scroll animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);
    
    // Observe product cards for scroll animation
    productCards.forEach(card => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(0px)';
        card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(card);
    });
});
